var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstratgiaCandidatura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Estrat\xC3\xA9gia Candidatura",
    clipPath: "url(#clip0_407_748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0001 20.3167C15.1682 20.3167 13.6833 18.8319 13.6833 17C13.6833 15.1681 15.1682 13.6832 17.0001 13.6832C18.832 13.6832 20.3169 15.1681 20.3169 17C20.3169 18.8319 18.832 20.3167 17.0001 20.3167ZM17.0001 15.3412C16.0837 15.3412 15.3413 16.0836 15.3413 17C15.3413 17.9164 16.0837 18.6588 17.0001 18.6588C17.9165 18.6588 18.6589 17.9164 18.6589 17C18.6589 16.0836 17.9165 15.3412 17.0001 15.3412Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.5123 16.1711C31.077 8.80114 25.1989 2.92304 17.829 2.48779V0H16.1711V2.48779C8.80115 2.92304 2.92304 8.80114 2.48779 16.1711H0V17.829H2.48779C2.92304 25.1989 8.80115 31.077 16.1711 31.5122V34H17.829V31.5122C25.1989 31.077 31.077 25.1989 31.5123 17.829H34V16.1711H31.5123ZM25.359 17.829C24.9609 21.8112 21.8112 24.9609 17.829 25.359V21.9756H16.1711V25.359C12.1889 24.9609 9.0391 21.8112 8.64106 17.829H12.0245V16.1711H8.64106C9.0391 12.1889 12.1889 9.0391 16.1711 8.64105V12.0244H17.829V8.64105C21.8112 9.0391 24.9609 12.1889 25.359 16.1711H21.9756V17.829H25.359ZM16.1711 4.97557V6.97879C11.2734 7.38981 7.38808 11.2742 6.97446 16.1711H4.97557C5.40217 10.1735 10.1735 5.40217 16.1711 4.97557ZM4.97557 17.829H6.97879C7.38982 22.7267 11.2742 26.612 16.1711 27.0256V29.0245C10.1735 28.5979 5.40217 23.8265 4.97557 17.829ZM17.829 29.0245V27.0256C22.7276 26.6146 26.6146 22.7275 27.0256 17.829H29.0245C28.5979 23.8265 23.8265 28.5979 17.829 29.0245ZM27.0256 16.1711C26.6146 11.2725 22.7276 7.38548 17.829 6.97445V4.97557C23.8265 5.40217 28.5979 10.1735 29.0245 16.1711H27.0256Z",
    fill: "#FFC000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_407_748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstratgiaCandidatura);
export default __webpack_public_path__ + "static/media/Estratégia Candidatura.69c2bd88cd780d66ced836ab9e5a4c27.svg";
export { ForwardRef as ReactComponent };